const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./product/details'));
    processInclude(require('sunnie_foods/product/wishlist'));

    $(document).ready(function() {
        $('#goToNutritionalInfo').on('click', function(event) {
            event.preventDefault();
            var $targetElement = $('[id^="product-info-container"]');

            if ($targetElement.length > 0) {
                var targetOffset = $targetElement.first().offset().top - 150;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 1000);
            } else {
                console.error('ID not found');
            }
        });


        $('#imageZoomModal').on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget);
            var masterUrl = button.attr('data-master') || button.attr('src');
            var modal = $(this);
            modal.find('#zoomModalImage').attr('src', masterUrl);

            // Highlight active thumbnail
            modal.find('.modal-thumbnail').css({
                'opacity': '0.6',
                'border': '1px solid #dee2e6'
            });
            modal.find('.modal-thumbnail[data-master="' + masterUrl + '"]').css({
                'opacity': '1',
                'border': '2px solid #5f702b'
            });
        });

        // Thumbnail click handler
        $('#imageZoomModal').on('click', '.modal-thumbnail', function() {
            var masterUrl = $(this).attr('data-master') || $(this).attr('src');
            var modal = $('#imageZoomModal');
            // Switch image
            modal.find('#zoomModalImage').attr('src', masterUrl);
            // Reset Zoom
            modal.find('#zoomModalImage').css({
                'transform': 'scale(1)',
                'transform-origin': 'center center'
            });
            // Update styles
            modal.find('.modal-thumbnail').css({
                'opacity': '0.6',
                'border': '1px solid #dee2e6'
            });
            $(this).css({
                'opacity': '1',
                'border': '2px solid #5f702b'
            });
        });

        $('#imageZoomModal .zoom-image-container').on('mousemove', function (e) {
            var container = $(this);
            var image = container.find('#zoomModalImage');
            
            var offset = container.offset();
            var xRel = e.pageX - offset.left;
            var yRel = e.pageY - offset.top;
            
            var width = container.width();
            var height = container.height();

            var xPercent = (xRel / width) * 100;
            var yPercent = (yRel / height) * 100;

            image.css({
                'transform-origin': xPercent + '% ' + yPercent + '%',
                'transform': 'scale(1.8)'
            });
        }).on('mouseleave', function () {
            var image = $(this).find('#zoomModalImage');
            image.css({
                'transform': 'scale(1)',
                'transform-origin': 'center center'
            });
        });
    });
    
});